export const 
	COVERS_LOAD_REQ		= 'COVERS_LOAD_REQ',
	COVERS_LOAD_SUCCESS	= 'COVERS_LOAD_SUCCESS',
	COVERS_LOAD_ERROR	= 'COVERS_LOAD_ERROR'